var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3299 3.33993C12.2635 3.3144 12.1971 3.29908 12.1256 3.29908L5.9616 3.30419C5.6654 3.30419 5.42027 3.54932 5.42027 3.84552C5.42027 4.14171 5.6654 4.38684 5.9616 4.38685L10.8131 4.38685L3.49506 11.7049C3.28568 11.9143 3.28568 12.2616 3.49506 12.471C3.70445 12.6803 4.05171 12.6803 4.2611 12.471L11.5843 5.14777L11.5843 9.99931C11.5843 10.2955 11.8294 10.5406 12.1256 10.5406C12.2788 10.5406 12.4116 10.4794 12.5086 10.3823C12.6057 10.2853 12.6669 10.1525 12.6669 9.99931V3.84041C12.6669 3.76891 12.6516 3.70252 12.6261 3.63613C12.5648 3.50335 12.4627 3.40122 12.3299 3.33993Z",
    fill: "#518BF8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBlue);
export default __webpack_public_path__ + "static/media/icon_arrow_blue.114b2aba.svg";
export { ForwardRef as ReactComponent };